<script lang="ts">
export default {
	name: 'ButtonItem',
	props: {
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		msg: {
			type: String,
			required: true,
			default: 'Button Title',
		},

		design: {
			type: Object,
			required: false,
			default: () => ({
				fontSize: 'font-size',
				height: 'height',
				width: 'width',
			}),
		},
		icon: {
			type: [Object, Function],
			required: false,
			default: null,
		},
	},
	methods: {
		unfocus(e: Event) {
			(e.target as HTMLElement).blur();
		},
	},
};
</script>

<template>
	<button
		:disabled="disabled"
		@click="unfocus"
		:style="{
			border: design.border,
			width: design.width,
			fontSize: design.fontSize,
			height: design.height,
		}"
		class="button">
		<component v-if="icon" :is="icon" class="button-icon" />

		<slot />
		<div :style="{ opacity: disabled ? '0.7' : 1 }">{{ msg }}</div>
	</button>
</template>

<style scoped>
.button {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap:.5rem;
  background-color: var(--button-bg, var(--factstory));
  	outline: none;
	border: none;
	color: var(--text);
	font-size: 1rem;
	font-weight: 600;
	padding: 5px 15px;
	border-radius: 10px;
	transition: all 0.3s ease-out;
	text-overflow: ellipsis;
	overflow: hidden;
}

.button:hover:not(:disabled) {
	cursor: pointer;
  background-color: var(--button-hover, var(--blue-marine));
}

button:disabled,
button[disabled] {
	background-color: var(--bg3);
}
</style>
